import React, { type Dispatch, type SetStateAction, useCallback } from "react";
import { SupRadio, SupText } from "@repo/core-ui";
import { SupStoredTxSettings, SupStoredTxSettingsRoutePriority } from "@/types";

interface Web3TxSettingsGroupRouteTypeProps {
  settings: SupStoredTxSettings;
  setSettings: Dispatch<SetStateAction<SupStoredTxSettings>>;
}

export default function Web3TxSettingsGroupRouteType({ settings, setSettings }: Web3TxSettingsGroupRouteTypeProps) {
  const routeTypeList = {
    output: "MAX.OUTPUT",
    // "time": "FASTEST",
    // "gas": "CHEAPEST",
  } as Record<SupStoredTxSettingsRoutePriority, string>;

  const onSelectRouteType = useCallback(
    (value: SupStoredTxSettingsRoutePriority) => {
      if (settings.routePriority !== value) {
        setSettings(currentSettings => ({
          ...currentSettings,
          routePriority: value,
        }));
      }
    },
    [setSettings, settings]
  );

  return (
    <div className="">
      <SupText variant="subtitle1" className="mb-1">
        ROUTE PRIORITY
      </SupText>

      {Object.entries(routeTypeList).map(([value, label]) => (
        <div className="leading-12 flex h-12 w-full items-center" key={`route-type-${value}`}>
          <SupRadio
            label={label}
            name="route_type"
            onChange={() => onSelectRouteType(value as SupStoredTxSettingsRoutePriority)}
            value={value}
            checked={settings.routePriority == value}
          />
        </div>
      ))}
    </div>
  );
}
